import {useEffect, useState} from 'react';

/**
 * Fetches a pre-generated JSON pool from public/ai-content/<fileName> at runtime.
 * These files are produced offline by scripts/generate-ai-content.js - nothing here
 * ever calls OpenAI directly, so there is no key and no live request to worry about.
 * If the file doesn't exist yet (or the network fails), this just resolves to []
 * and the game silently falls back to its base pool.
 */
export function useAiContent<T>(fileName: string): T[] {
    const [items, setItems] = useState<T[]>([]);

    useEffect(() => {
        let cancelled = false;
        fetch(`${process.env.PUBLIC_URL}/ai-content/${fileName}`)
            .then(res => (res.ok ? res.json() : []))
            .then(data => {
                if (!cancelled && Array.isArray(data)) setItems(data);
            })
            .catch(() => {
                // no AI content yet, or offline - silently fall back to the base pool
            });
        return () => {
            cancelled = true;
        };
    }, [fileName]);

    return items;
}
